export default {
  setUpShippingConfigurationDrawerHeadline: {
    id: 'bo_seller.options.shipping.set_up_shipping_configuration.drawer.headline',
    defaultMessage: 'Manage weekend delivery',
  },
  setUpShippingConfigurationDrawerInstruction: {
    id: 'bo_seller.options.shipping.set_up_shipping_configuration.drawer.instruction',
    defaultMessage: 'Select shipping providers that deliver on weekends.',
  },
  setUpShippingConfigurationInstruction: {
    id: 'bo_seller.options.shipping.set_up_shipping_configuration.instruction',
    defaultMessage:
      'Set up weekday delivery before configuring weekend delivery.',
  },
  setUpShippingConfigurationAction: {
    id: 'bo_seller.options.shipping.set_up_shipping_configuration.action',
    defaultMessage: 'Set up shipping configuration',
  },
  setUpShippingConfigurationTrigger: {
    id: 'bo_seller.options.shipping.set_up_shipping_configuration.trigger',
    defaultMessage: 'Set up now',
  },
}
